export default __webpack_public_path__ + "static/media/wave.dbdcdd35.png";